import { FC, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Search, Tab, Tabs } from "@appkit4/react-components";
import { Role, ListType } from "routes/analysis/types/analysis";
import { searchFilter } from "services/common";
import Loader from "components/common/loader";
import { ActiveFilters } from "components/layout/filters/filters";
import { Floater, RoleItem, TechnicalRoles } from "routes/analysis/helpers/analysisHelpers";
import UserMatches from "../userMatches";
import { UserData } from "routes/analysis/types/user";

const UserRoles: FC<{ userData?: UserData }> = ({ userData }) => {
  const { analysisId, userId, roleId } = useParams();
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const roles = useMemo(() => userData?.roles || [], [userData]);

  const filteredData = useMemo(() => {
    return roles.filter(f => searchFilter(f, ["description", "name"], search));
  }, [roles, search]);

  return !roles
    ? <Loader loadingType="circular" />
    : (
      <>
        <div className="flex items-center gap-4 mt-4">
          <div>
            <Search
              searchType={"secondary"}
              onChange={(value: string) => setSearch(value)}
              className="list-filter"
            />
          </div>
        </div>
        <ActiveFilters rows={filteredData?.length || 0} />
        <Floater>
          <div
            className="ap-list-header ap-business-process-header flex gap-4 p-4 pt-6 pb-6 items-center w-full">
            <div className="basis-12">
            </div>
            <div className="basis-80">
              Role
            </div>
            <div className="basis-32">
              Role type
            </div>
            <div className="basis-28">One or more matches</div>
            <div className="basis-96">Valid from - Valid to</div>
          </div>
        </Floater>
        {
          filteredData?.map((role: Role) => (
            <div className="list-row pointer" key={role.roleId} id={role.name}>
              <Link to={role.roleId === roleId ? `/analysis/${analysisId}/user/${userId}` : `/analysis/${analysisId}/user/${userId}/role/${role.roleId}#${role.name}`} relative="path">
                <RoleItem open={roleId === role.roleId} role={role} />
              </Link>
              {
                roleId === role.roleId && (
                  <div className="ap-accordion-open">
                    {role.hasMatches && (
                      <div className="ap-wrapper-inline ap-wrapper-matches">
                        <Tabs activeIndex={activeIndex} onTabChange={(value) => setActiveIndex(value)}>
                          <Tab label="Matches" value="Matches">
                            <UserMatches userData={userData} type={role.isComposite ? ListType.CompositeRole : ListType.Role} typeId={role.roleId} />
                          </Tab>
                          <Tab label="Technical roles" value="Technical roles" disabled={!role.isComposite}>
                            <TechnicalRoles roles={role.roles || []} />
                          </Tab>
                        </Tabs>
                      </div>
                    )}
                  </div>
                )
              }
            </div>
          ))}
        {/* <Paginate
          getTotalPages={getTotalPages}
        /> */}
      </>
    )
}

export default UserRoles;
